import { isNumber, sortBy } from 'lodash'

import normalizeRadio from '../../util/normalizeRadio'

const resetRadios = (state) => {
  state.radios = []

  return state
}

export default {

  state: resetRadios({}),

  getters: {

    radios ({ radios }) {
      return sortBy(radios, 'frequency')
    },

    radioIndexesById (state, getters) {
      const indexes = {}

      getters.radios.forEach((radio, i) => {
        indexes[radio.id] = i
      })

      return indexes
    },

    radioById (state, getters) {
      return (id) => {
        return getters.radios[getters.radioIndexesById[id]]
      }
    }

  },

  mutations: {

    resetRadios,

    createRadio (state, radio) {
      state.radios.push(normalizeRadio(radio))
    },

    updateRadio (state, { i, data }) {
      state.radios[i] = normalizeRadio({
        ...state.radios[i],
        ...data
      })
    },

    deleteRadio (state, i) {
      if (state.radios[i]) {
        state.radios.splice(i, 1)
      }
    }

  },

  actions: {

    spawnRadio ({ commit }, radio) {
      commit('createRadio', radio)
    },

    updateRadio ({ commit, getters }, { id, data }) {
      if (isNumber(getters.radioIndexesById[id])) {
        commit('updateRadio', {
          i: getters.radioIndexesById[id],
          data
        })
      }
    },

    toggleRadioPower ({ dispatch }, { id, isOn }) {
      dispatch('updateRadio', {
        id,
        data: {
          isOn: !!isOn
        }
      })
    },

    changeRadioFrequency ({ dispatch, getters }, { id, frequency }) {
      dispatch('updateRadio', {
        id,
        data: {
          frequency
        }
      })
    },

    moveRadio ({ dispatch, getters }, { id, x, y }) {
      dispatch('updateRadio', {
        id,
        data: {
          ...(isNumber(x) ? { locationX: x } : {}),
          ...(isNumber(y) ? { locationY: y } : {})
        }
      })
    },

    destroyRadioById ({ commit, getters }, id) {
      if (isNumber(getters.radioIndexesById[id])) {
        commit('deleteRadio', getters.radioIndexesById[id])
      }
    }

  }

}
